import { ProductCategoryAttributes, ProductCategoryProduct } from '@/types'
import { CreateProductCategoryMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<ProductCategoryAttributes>
}

export const Form = ({ onSuccess, defaultValues }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateProductCategoryMutation, ProductCategoryAttributes, never, never>({
    defaultValues: {
      categoryId: '',
      productId: '',
      productType: ProductCategoryProduct.AssetType,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createProductCategory',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Category', field: 'categoryId', type: 'category' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
